import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/tv_user_swap_panel.svg")